import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class PricingPlansService {
    constructor(private http: HttpClient) {}

    // paginated
    getPlans(filter?: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}pricing_plans`, filter);
    }

    // without pagination
    getAllPlans(): Observable<any> {
        return this.http.get(`${environment.apiUrl}pricing_plans/all`);
    }
    /**
     * Get pricing plans by product
     */
    getPricingPlansByProduct(productId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}pricing_plans/by-product/${productId}`);
    }

    // create new and archive existing on stripe + update db
    createPlan(data: any): Observable<object> {
        return this.http.post(
            `${environment.apiUrl}pricing_plans/create`,
            data
        );
    }

    // create new and archive existing on stripe + update db
    updatePlan(id: string, data: any): Observable<object> {
        return this.http.put(
            `${environment.apiUrl}pricing_plans/update/${id}`,
            data
        );
    }

    // delete from db + archive on stripe
    deletePlan(id: string): Observable<void> {
        return this.http.delete<void>(
            `${environment.apiUrl}pricing_plans/delete/${id}`
        );
    }
}
